/*
auto-generated by: https://github.com/react-spring/gltfjsx
*/

import * as THREE from 'three';
import React, { useRef, useEffect } from 'react';
import { useLoader } from 'react-three-fiber';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { draco } from 'drei';
import gsap from 'gsap';
import { useFrame } from 'react-three-fiber';

const img1 = require('./ARTISTAS_TOOLKIT/SNOW_YUNXUE_FU/img1.jpeg');
const img2 = require('./ARTISTAS_TOOLKIT/SNOW_YUNXUE_FU/img2.jpeg');
const img3 = require('./ARTISTAS_TOOLKIT/SNOW_YUNXUE_FU/img3.jpeg');

const img1Emilie = require('./ARTISTAS_TOOLKIT/EMILIE_GERVAIS/IMG-5209.JPG');
const img2Emilie = require('./ARTISTAS_TOOLKIT/EMILIE_GERVAIS/IMG-5211.JPG');
const img3Emilie = require('./ARTISTAS_TOOLKIT/EMILIE_GERVAIS/IMG-5212.JPG');

const img1Domenico = require('./ARTISTAS_TOOLKIT/DOMENICO_BARRA/img1.jpg');
const img2Domenico = require('./ARTISTAS_TOOLKIT/DOMENICO_BARRA/img2.jpg');
const img3Domenico = require('./ARTISTAS_TOOLKIT/DOMENICO_BARRA/img3.jpg');

const img1Sandra = require('./ARTISTAS_TOOLKIT/SANDRA_ARAUJO/02.JPG');
const img2Sandra = require('./ARTISTAS_TOOLKIT/SANDRA_ARAUJO/03.JPG');
const img3Sandra = require('./ARTISTAS_TOOLKIT/SANDRA_ARAUJO/04.JPG');

const img1Haydiroley = require('./ARTISTAS_TOOLKIT/HAYDIROKET/HAYDIROKET-GLOBAL-WARNING.JPG');
const img2Haydiroley = require('./ARTISTAS_TOOLKIT/HAYDIROKET/HAYDIROKET-NO_JUSTICE_NO_PEACE.JPG');
const img3Haydiroley = require('./ARTISTAS_TOOLKIT/HAYDIROKET/HAYDIROKET-TRUMINATI.png');

export default function IPhoneModel(props) {
  const group = useRef();
  const phoneRef = useRef();
  const { nodes, materials } = useLoader(
    GLTFLoader,
    '/models/phone_HDDM_B.gltf',
    draco('/draco-gltf/')
  );

  const wallMaterial = new THREE.MeshStandardMaterial({
    color: 0xffffff,
  });

  const videoID = document.getElementById('video-screen');
  const texture = new THREE.VideoTexture(videoID);
  texture.needsUpdate = true;
  const basicVideoMaterial = new THREE.MeshLambertMaterial({
    map: texture,
    emissiveMap: texture,
    // emissiveIntensity: 1,
    // emissive: 0xffffff,
  });

  // SNOW
  const videoSnow = document.getElementById('video-snow');
  const textureVidSnow = new THREE.VideoTexture(videoSnow);
  texture.needsUpdate = true;
  const basicVideoMaterialSnow = new THREE.MeshLambertMaterial({
    map: textureVidSnow,
    emissiveMap: textureVidSnow,
    // emissiveIntensity: 1,
    // emissive: 0xffffff,
  });

  const img1Tex = new THREE.TextureLoader().load(img1);
  const img1Material = new THREE.MeshStandardMaterial({
    map: img1Tex,
    DoubleSide: false,
  });
  const img2Tex = new THREE.TextureLoader().load(img2);
  const img2Material = new THREE.MeshStandardMaterial({
    map: img2Tex,
    DoubleSide: false,
  });
  const img3Tex = new THREE.TextureLoader().load(img3);
  const img3Material = new THREE.MeshStandardMaterial({
    map: img3Tex,
    DoubleSide: false,
  });

  // EMILIE
  const videoEmilie = document.getElementById('video-emilie');
  const textureVidEmilie = new THREE.VideoTexture(videoEmilie);
  textureVidEmilie.needsUpdate = true;
  const basicVideoMaterialEmilie = new THREE.MeshLambertMaterial({
    map: textureVidEmilie,
    emissiveMap: textureVidEmilie,
    // emissiveIntensity: 1,
    // emissive: 0xffffff,
  });

  const img1EmilieTex = new THREE.TextureLoader().load(img1Emilie);
  const img1EmilieMaterial = new THREE.MeshStandardMaterial({
    map: img1EmilieTex,
    DoubleSide: false,
  });
  const img2EmilieTex = new THREE.TextureLoader().load(img2Emilie);
  const img2EmilieMaterial = new THREE.MeshStandardMaterial({
    map: img2EmilieTex,
    DoubleSide: false,
  });
  const img3EmilieTex = new THREE.TextureLoader().load(img3Emilie);
  const img3EmilieMaterial = new THREE.MeshStandardMaterial({
    map: img3EmilieTex,
    DoubleSide: false,
  });

  // DOMENICO
  const videoDomenico = document.getElementById('video-domenico');
  const textureVidDomenico = new THREE.VideoTexture(videoDomenico);
  textureVidDomenico.needsUpdate = true;
  const basicVideoMaterialDomenico = new THREE.MeshLambertMaterial({
    map: textureVidDomenico,
    emissiveMap: textureVidDomenico,
    // emissiveIntensity: 1,
    // emissive: 0xffffff,
  });

  const img1DomenicoTex = new THREE.TextureLoader().load(img1Domenico);
  const img1DomenicoMaterial = new THREE.MeshStandardMaterial({
    map: img1DomenicoTex,
    DoubleSide: false,
  });
  const img2DomenicoTex = new THREE.TextureLoader().load(img2Domenico);
  const img2DomenicoMaterial = new THREE.MeshStandardMaterial({
    map: img2DomenicoTex,
    DoubleSide: false,
  });
  const img3DomenicoTex = new THREE.TextureLoader().load(img3Domenico);
  const img3DomenicoMaterial = new THREE.MeshStandardMaterial({
    map: img3DomenicoTex,
    DoubleSide: false,
  });

  // SANDRA
  const videoSandra = document.getElementById('video-sandra');
  const textureVidSandra = new THREE.VideoTexture(videoSandra);
  textureVidSandra.needsUpdate = true;
  const basicVideoMaterialSandra = new THREE.MeshLambertMaterial({
    map: textureVidSandra,
    emissiveMap: textureVidSandra,
    // emissiveIntensity: 1,
    // emissive: 0xffffff,
  });

  const img1SandraTex = new THREE.TextureLoader().load(img1Sandra);
  const img1SandraMaterial = new THREE.MeshStandardMaterial({
    map: img1SandraTex,
    DoubleSide: false,
  });
  const img2SandraTex = new THREE.TextureLoader().load(img2Sandra);
  const img2SandraMaterial = new THREE.MeshStandardMaterial({
    map: img2SandraTex,
    DoubleSide: false,
  });
  const img3SandraTex = new THREE.TextureLoader().load(img3Sandra);
  const img3SandraMaterial = new THREE.MeshStandardMaterial({
    map: img3SandraTex,
    DoubleSide: false,
  });

  // haydiroley
  const videoHaydiroley = document.getElementById('video-haydiroley');
  const textureVidHaydiroley = new THREE.VideoTexture(videoHaydiroley);
  textureVidHaydiroley.needsUpdate = true;
  const basicVideoMaterialHaydiroley = new THREE.MeshLambertMaterial({
    map: textureVidHaydiroley,
    emissiveMap: textureVidHaydiroley,
    // emissiveIntensity: 1,
    // emissive: 0xffffff,
  });

  const img1HaydiroleyTex = new THREE.TextureLoader().load(img1Haydiroley);
  const img1HaydiroleyMaterial = new THREE.MeshStandardMaterial({
    map: img1HaydiroleyTex,
    DoubleSide: false,
  });
  const img2HaydiroleyTex = new THREE.TextureLoader().load(img2Haydiroley);
  const img2HaydiroleyMaterial = new THREE.MeshStandardMaterial({
    map: img2HaydiroleyTex,
    DoubleSide: false,
  });
  const img3HaydiroleyTex = new THREE.TextureLoader().load(img3Haydiroley);
  const img3HaydiroleyMaterial = new THREE.MeshStandardMaterial({
    map: img3HaydiroleyTex,
    DoubleSide: false,
  });

  const textureArtist = {
    snow: [basicVideoMaterialSnow, img1Material, img2Material, img3Material],
    emilie: [basicVideoMaterialEmilie, img1EmilieMaterial, img2EmilieMaterial, img3EmilieMaterial],
    domenico: [
      basicVideoMaterialDomenico,
      img1DomenicoMaterial,
      img2DomenicoMaterial,
      img3DomenicoMaterial,
    ],
    haydiroley: [
      basicVideoMaterialHaydiroley,
      img1HaydiroleyMaterial,
      img2HaydiroleyMaterial,
      img3HaydiroleyMaterial,
    ],
    sandra: [basicVideoMaterialSandra, img1SandraMaterial, img2SandraMaterial, img3SandraMaterial],
  };

  useEffect(() => {
    if (props.artist === 'snow') {
      gsap.to(phoneRef.current.rotation, {
        duration: 2,
        x: 0,
        y: Math.PI / 2,
        z: Math.PI / 2,
      });
      console.log("snow")
    } else {
      gsap.to(phoneRef.current.rotation, {
        duration: 2,
        x: 0,
        y: Math.PI / 2,
        z: 0,
      });console.log("else")
    }
  }, [props.artist]);

  return (
    <group ref={group} {...props} dispose={null}>
      <group
        ref={phoneRef}
        position={[0, 0, 0]}
        rotation={[0, Math.PI, 0]}
        scale={[7.858202, 7.858202, 7.858202]}
      >
        <mesh material={materials.IPHONE} geometry={nodes['Cube.001_0'].geometry} />
        <mesh
          material={textureArtist[props.artist][props.artwork]}
          geometry={nodes['Cube.001_1'].geometry}
          rotation={[0, 0, Math.PI]}
          position={[0, 0, 0.0005]}
        />
      </group>
    </group>
  );
}
